import { useEffect, useState, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Iframe from "react-iframe";
import style from "./index.module.scss";
import { Box, Breadcrumbs, Stack, Typography } from "@mui/material";
import Links from "@mui/material/Link";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { initializeProcess } from "./workflow";
import { useConfigStore } from "../../assets/config";
import Loading from "../../components/Loading";


const InitiateProcessPage = () => {
  const [loading, setLoading] = useState(true);

  
  // Get processAssociationId from navigation state
  const location = useLocation();
  const processAssociationId = location.state?.id || "";
  
  const { t } = useTranslation();
  const navigate = useNavigate();
    const id = location.state?.id as string;
    const xevmpdId = location.state?.params?.xevmpdId as string;
  
    // Handle breadcrumb navigation to view-xevmpd
    const handleBreadcrumbClick = () => {
   
      navigate("/view-xevmpd", { state: { params, mode: "view" } });
    };
    const params= location.state?.params as any;
  const origin = window.location.origin.replace('xevmpd.', 'PAT.');


  const IframeUrl = `${origin}/process/initiate?processAssociationId=${processAssociationId}`;
  console.log("IframeUrl", IframeUrl);
  console.log("processAssociationId", processAssociationId);

  const initiateComplete = (params: API.PostProcessBody) => {
    setLoading(true);

    
    initializeProcess(params)
      .then((res: any) => {
        console.log("initializeProcess response:", res);
        // Handle nested response structure (axios response.data)
        let responseCode: number | undefined;
        let responseData: any;
        
        if (res && typeof res === 'object') {
          if ('code' in res) {
            // Direct structure: { code, message, data }
            responseCode = res.code;
            responseData = res.data;
          } else if ('data' in res && res.data && typeof res.data === 'object' && 'code' in res.data) {
            // Nested structure: { data: { code, message, data } }
            responseCode = res.data.code;
            responseData = res.data.data;
          }
        }
        
        // Navigate after successful process initiation
        if (responseCode === 200 && responseData) {
          setTimeout(() => {
            navigate("/xevmpd");
          }, 1000);
        } else {
          // Navigate even if response structure is different, after a delay
          setTimeout(() => {
            navigate("/xevmpd");
          }, 2000);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    const handlePTMessage = (event: any) => {
      const { type } = event.data;
      console.log("init process type", type);

      switch (type) {
        case "ptAssociateCancel":
          navigate("/xevmpd");
          break;
        case "ptAssociateSuccess":
          navigate("/xevmpd");
          break;
        case "ptInitiateComplete":
          initiateComplete(event.data.data.extraData);
          // navigate("/applicationdetails")
          break;
        default:
          break;
      }
    };
    window.addEventListener("message", handlePTMessage);
    return () => {
      window.removeEventListener("message", handlePTMessage);
    };
  }, []);
  const { language } = useConfigStore();
  return (
    <>
      <Box>
        <Stack>
          <div style={{ marginTop: "16px", marginLeft: "32px" }}>
            <Breadcrumbs
              id="breadcrumb-initiate-process"
              aria-label="breadcrumb"
              separator={<span>/</span>}
              sx={{
                "& .MuiBreadcrumbs-separator": {
                  marginLeft: "12px", // Space BEFORE separator (after item)
                  marginRight: "12px", // Space AFTER separator (before next item)
                },
              }}
            >
              <Links href="/xevmpd" sx={{ color: "#295ef1", fontWeight: 400 }}>
                {t("xEVMPD")}
              </Links>
              <Links
                onClick={handleBreadcrumbClick}
                sx={{ color: "#295ef1", fontWeight: 400 }}
              >
                {"xEVMPD-" + xevmpdId}
              </Links>
              <Typography
                data-testid="breadcrumb-edit-app"
                // sx={{ color: "#737373" }}
              >
                {t("workflow.initiateProcess")}
              </Typography>
            </Breadcrumbs>
          </div>
        </Stack>
      </Box>

      {!!IframeUrl ? (
        <Iframe
          className={style["document-iframe"]}
          id="application_initiate_process_iframe"
          url={IframeUrl}
          width="100%"
          frameBorder={0}
          allow="clipboard-read; clipboard-write"
          onLoad={() => {
            setTimeout(() => {
              const curIframe = document.getElementById(
                "application_initiate_process_iframe",
              ) as HTMLIFrameElement | null;
              curIframe?.contentWindow?.postMessage(
                {
                  type: "globalLanguageChange",
                  data: language,
                },
                origin,
              );
              setLoading(false);
            }, 600);
          }}
        />
      ) : null}
      <Loading open={loading} />
    </>
  );
};

export default InitiateProcessPage;